import { useEffect, useState } from 'react';

import { faCheck, faXmark } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';

import { ErrorDetail, YearClosureProgressData } from '../types';

import { Box, LinearProgress, Link, Typography } from '@mui/material';

import { FontAwesomeSvgIcon } from 'components/shared';

interface Props {
  progress: YearClosureProgressData;
  title: string;
  errors?: ErrorDetail[];
  onErrorClick: () => void;
}

export const YearClosureProgress = ({
  progress,
  title,
  errors,
  onErrorClick
}: Props) => {
  const { t } = useTranslation('common');
  const [calculatedProgress, setCalculatedProgress] = useState(0);

  useEffect(() => {
    const calculated = Math.round(
      (progress.dutyLinesProgress / progress.dutyLinesTotal) * 100
    );
    setCalculatedProgress(isNaN(calculated) ? 100 : calculated);
  }, [progress]);

  return (
    <>
      <Box display={'flex'}>
        {errors && errors.length > 0 ? (
          <FontAwesomeSvgIcon
            fontSize={'small'}
            icon={faXmark}
            sx={{
              color: 'red'
            }}
          />
        ) : (
          <FontAwesomeSvgIcon
            fontSize={'small'}
            icon={faCheck}
            sx={{
              color: 'green'
            }}
          />
        )}
        <Box sx={{ width: 120, mr: 1, ml: 1 }}>{title}</Box>
        <Box
          display="flex"
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Box sx={{ width: 80, mr: 1 }}>
            <LinearProgress variant="determinate" value={calculatedProgress} />
          </Box>
          <Box sx={{ width: 50, color: 'red' }}>
            <Typography variant="body2" color="text.secondary">
              {calculatedProgress} %
            </Typography>
          </Box>
          {errors && errors.length > 0 ? (
            <Link component="button" variant="body2" onClick={onErrorClick}>
              {errors.length} {t('errors')}
            </Link>
          ) : (
            <Box sx={{ width: 100 }}>
              {errors?.length} {t('errors')}
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};
